<div class="reports-container">
  <qx-pbi-embedded [page]="false"
                   [isDahsboard]="true"
                   [container]="'container'"
                   [embeddedConfig]='embedConfig'></qx-pbi-embedded>
</div>